import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter, createBrowserRouter, RouterProvider } from "react-router-dom";
import { CookiesProvider } from 'react-cookie'
import reportWebVitals from './reportWebVitals';
import Home from "./pages/Home";
import Login from "./pages/Login";
import Header from "./components/Header";
import StrainOverview from "./pages/Strains/Overview";
import StrainDetail from "./pages/Strains/Detail";
import StrainDetailCGView from "./pages/Strains/DetailCGView";
import GeneOverview from "./pages/GeneFamilies/Overview";
import GeneDetail from "./pages/GeneFamilies/Detail";
import GeneNameOverview from "./pages/GeneNames/Overview";
import VFGeneNameOverview from "./pages/GeneNames/VFGenes";
import VFGeneDetail from "./pages/GeneNames/VFGenesDetail";
import GeneNameDetail from "./pages/GeneNames/Detail";
import VirulenceOverview from "./pages/Virulence/Overview";
import ResistanceOverview from "./pages/Resistance/Overview";
import PhenotypeOverview from "./pages/Phenotypes/Overview";
import SampleManagement from "./pages/UploadFiles/SampleManagement";
import Phylotree from './pages/StrainPhylotree/Phylotree';
import WorkflowContext from "./workflowContext";
import Forcetree from "./pages/Forcetree";
import authApiService from "./services/authApiService";
import UserProfile from "./pages/UserProfile/UserProfile";
import { useCookies } from 'react-cookie';



//pages

// DataSets pages
import Data from "./Data";
// import DataIndex from "./pages/DataSets/index";
import Carousel from "./pages/DataSets/Carousel";
import SampleCarousel from './pages/DataSets/SampleCarousel';


// Samples pages
import NewSample from "./pages/DataSets/NewSample";
import CreateSample from "./pages/DataSets/CreateSample";
import SampleDetails from './pages/DataSets/SampleDetails';
import SampleList from "./pages/DataSets/SampleList";

import ExistingSample from './pages/DataSets/ExistingSample';
import FailedSample from './pages/DataSets/FailedSample';
import MergeSample from './pages/DataSets/MergeSample';
import DataSetDetails from './pages/DataSets/DataSetDetails';


import FileList from './pages/Files/FileList';
import Upload from './pages/Files/Upload';

import UserManagement from "./UserManagement";
import UserManagementIndex from "./pages/UserManagement/index";
import Workflows from "./Workflows";
import WorkflowsIndex from "./pages/Workflows/index";
import WorkflowSelect from './pages/Workflows/select';
import WorkflowRun from './pages/Workflows/run';

import ConfigKeys from "./pages/Workflows/ConfigKeys";
import ConfigKey from "./pages/Workflows/ConfigKey";
import ConfigKeyNew from "./pages/Workflows/ConfigKeyNew";

import ConfigValues from "./pages/Workflows/ConfigValues";
import ConfigValue from "./pages/Workflows/ConfigValue";

import Visualizations from "./Visualizations";
import Welcome from "./pages/Welcome";


// React Google Analytics 4 Config
import ReactGA from "react-ga4";
import { get } from 'react-hook-form';
import ErrorBoundary from './pages/Error';
import Similarity from './pages/Similarity';
import Query from './pages/Strains/Query';
import FileDetails from './pages/Files/FileDetails';

import MultiQC from './pages/MultiQC/ReportView';
import CgView from './pages/Cgview';
import LinearPhylotree from './pages/StrainPhylotree/LinearPhylotree';


if (process.env.REACT_APP_ENVIRONMENT === "production") {
    ReactGA.initialize(process.env.REACT_APP_GA4_ID);
}

const getCookieValue = (name) => (
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
)

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: '',
                element: <Welcome />
            },
            {
                path: 'userProfile',
                element: <UserProfile />
            },
            {
                path: 'datasets',
                element: <Data />,
                children: [
                    {
                        path: '',
                        element: <Carousel />
                    },
                    {
                        path: 'view_sample',
                        element: <SampleCarousel />
                    },
                    {
                        path: 'manage_sample/new_sample/upload-csv',
                        element: <NewSample />,
                        // loader: async ({ params }) => {
                        //     return fetch(`/api/teams/${params.teamId}.json`);
                        // }
                    },
                    {
                        path: 'manage_sample/sample',
                        element: <ExistingSample />,
                        // loader: async ({ params }) => {
                        //     return fetch(`/api/teams/${params.teamId}.json`);
                        // }
                    },
                    {
                        path: 'manage_sample/failed_sample',
                        element: <FailedSample />,
                        // loader: async ({ params }) => {
                        //     return fetch(`/api/teams/${params.teamId}.json`);
                        // }
                    },
                    {
                        path: 'manage_sample/merge_sample',
                        element: <MergeSample />,
                        // loader: async ({ params }) => {
                        //     return fetch(`/api/teams/${params.teamId}.json`);
                        // }
                    },
                    {
                        path: 'create_sample',
                        element: <CreateSample />,
                    },
                    {
                        path: 'sample_details',
                        element: <SampleDetails />,
                    },
                    {
                        path: 'list_samples',
                        element: <SampleList />,
                    },
                    {
                        path: 'dataset_details',
                        element: <DataSetDetails />,
                        // loader: async ({ params }) => {
                        //     return fetch(`/api/teams/${params.teamId}.json`);
                        // }
                    },
                    {
                        path: 'files',
                        element: <FileList />
                    },
                    {
                        path: 'files/filedetails/:id',
                        element: <FileDetails />
                    },
                    {
                        path: 'files/upload',
                        element: <Upload />
                    }
        
                    
                ]
            },
            {
                path: 'workflows',
                element: <Workflows />,
                children: [
                    {
                        path: '',
                        element: <WorkflowsIndex />
                    },
                    {
                        path: 'select',
                        element: <WorkflowSelect />
                    },
                    {
                        path: 'run',
                        element: <WorkflowRun />
                    },
                    {
                        path: 'config/:id',
                        element: <ConfigKey />
                    },
                    {
                        path: 'config/new',
                        element: <ConfigKeyNew />
                    },
                    {
                        path: 'config',
                        element: <ConfigKeys />
                    },
                    {
                        path: 'configvalue/:id',
                        element: <ConfigValue />
                    },
                    {
                        path: 'configvalue',
                        element: <ConfigValues />
                    }
                ]
            },
            {
                path: 'visualizations',
                element: <Visualizations />,
                children: [
                    {
                        path: '',
                        // element: <Welcome />
                        element: <Home />
                    },
                    {
                        path: 'visualize',
                        element: <Home />
                    },
                    {
                        path: 'strains',
                        element: <StrainOverview />
                    },
                    {
                        path: 'strains/detail/:id',
                        element: <StrainDetail />
                    },
                    {
                        path: 'strains/detail/cgview/:id',
                        element: <StrainDetailCGView />
                    },
                    {
                        path: 'strains/detail',
                        element: <StrainDetail />
                    },
                    {
                        path: 'strains/query',
                        element: <Query/>
                    },
                    {
                        path: 'gene-families',
                        element: <GeneOverview />
                    },
                    {
                        path: 'gene-families/detail/:id',
                        element: <GeneDetail />
                    },
                    {
                        path: 'gene-families/detail',
                        element: <GeneDetail />
                    },
                    {
                        path: 'gene-names',
                        element: <GeneNameOverview />
                    },
                    {
                        path: 'vf-genes',
                        element: <VFGeneNameOverview />
                    },
                    {
                        path: 'gene-names/detail/:id',
                        element: <GeneNameDetail />
                    },
                    {
                        path: 'gene-names/detail',
                        element: <GeneNameDetail />
                    },
                    {
                        path: 'vf-genes/detail/:id',
                        element: <VFGeneDetail />
                    },
                    {
                        path: 'virulence',
                        element: <VirulenceOverview />
                    },
                    {
                        path: 'resistance',
                        element: <ResistanceOverview />
                    },
                    {
                        path: 'phenotypes',
                        element: <PhenotypeOverview />
                    },
                    {
                        path: 'phylotree',
                        element: <Phylotree />
                    },
                    {
                        path:'linearphylotree',
                        element: <LinearPhylotree />
                    },
                    {
                        path: 'forcetree',
                        element: <Forcetree />
                    },
                    {
                        path: 'epinetwork',
                        element: <Similarity />
                    },
                    {
                        path: 'multiqc',
                        element: <MultiQC />
                    },
                    {
                        path: 'cgview/:id',
                        element: <CgView />
                    },
                    {
                        path: 'cgview',
                        element: <CgView />
                    }
        
        
        
                ]
            },
            {
                path: 'usermanagement',
                element: <UserManagement />,
                children: [
                    {
                        path: '',
                        element: <UserManagementIndex />
                    },
                ]
            }, 
        ]
    },
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <CookiesProvider>
            <RouterProvider router={router}/>
        </CookiesProvider>
    </React.StrictMode>
);

// const SendAnalytics = () => {
//     ReactGA.send({ hitType: "pageview", page: window.location.pathname });
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// reportWebVitals(SendAnalytics);
